module.exports = __webpack_public_path__ + "img/feedDesc.a07d1313.png";